import {
  RouterSelectors,
  createPrefixedActions,
} from '@zapier/toolbox-redux-framework';
import { urlWithNext } from '@zapier/url-utils';
import { Profile } from '@zapier/shared-entities';

const ActionTypes = createPrefixedActions(
  'login',
  `
    SESSION_TIMED_OUT
  `
);

const LoginActions = {
  redirectToLoginOrSignupPage({
    shouldPreferSignUp = false,
    replaceRoute = false,
  } = {}) {
    return (dispatch, getState) => {
      const state = getState();
      const nextUrl = RouterSelectors.currentUrl(state);
      const email = Profile.selectors.email(
        Profile.selectors.all.currentProfile(state)
      );
      const hasSessionTimedOut = !!email;

      const redirectUrl = urlWithNext(
        shouldPreferSignUp && !hasSessionTimedOut ? '/sign-up' : '/app/login',
        nextUrl
      );

      // If we're already on one of the `redirectUrl` pages, don't redirect again
      if (
        RouterSelectors.isCurrentUrlBlacklisted(state, [
          '/sign-up',
          '/app/login',
        ])
      ) {
        return undefined;
      }

      return dispatch({
        type: ActionTypes.SESSION_TIMED_OUT,
        routeTo: {
          path: redirectUrl,
          replace: replaceRoute,
        },
      });
    };
  },
};

export default LoginActions;
